//const swup = require("./components/swup")
const lazyBg = require("./components/lazyBg")
const animations = require("./components/animations")
const form = require('./components/form')
//const projectRequest = require('./components/projectRequest')
const lightboxGallery = require("./components/lightboxGallery");
const glightbox = require("./components/glightbox")
// const career_paths = require("./components/career_paths");

export const run = function () {
    form.load()
    //swup.load(0
    lazyBg.load()
    animations.load()
    lightboxGallery.load()
    glightbox.load()
    //projectRequest.load()
}

export default run